module.exports = __webpack_public_path__ + "clients2.png?36c0eb76ef30356e5e5af6cf894cce01";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients2.png
// module id = 370
// module chunks = 0